import { useCallback } from "react";
import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { BUILDING } from "tagTypes";

export const useBuildingQuery = (query = {}, blockId = "") =>
  useGetQuery({
    endpoint: `/block/${blockId}/building`,
    query,
    tags: [BUILDING],
  });

export const useLazyBuildingQuery = () => {
  const [getBuilding, data] = useLazyGetQuery();
  const building = useCallback(
    async (blockId = "", query = {}, isFireSafety = false) =>
      await getBuilding(
        {
          endpoint: isFireSafety
            ? `/firesafety-address/block/${blockId}/building`
            : `/block/${blockId}/building`,
          query,
          tags: [BUILDING],
        },
        true
      ).unwrap(),
    [getBuilding]
  );
  return [building, data];
};

export const usePostBuildingMutation = () => {
  const [building, data] = usePostMutation();
  const addBuilding = async (payload, query = {}) =>
    await building({
      endpoint: "/building",
      query,
      payload: payload || {},
      toastMessage: "Building added successfully",
      tags: [BUILDING],
    }).unwrap();

  return [addBuilding, data];
};

export const usePutBuildingMutation = () => {
  const [building, data] = usePutMutation();
  const updateBuilding = async (payload, buildingId, query = {}) =>
    await building({
      endpoint: `/building/${buildingId}`,
      query,
      payload: payload || {},
      toastMessage: "Building updated successfully",
      tags: [BUILDING],
    }).unwrap();
  return [updateBuilding, data];
};

export const useDeleteBuildingMutation = () => {
  const [building, data] = useDeleteMutation();
  const deleteBuilding = async (buildingId, query = {}) =>
    await building({
      endpoint: `/building/${buildingId}`,
      query,
      toastMessage: "Building deleted successully",
      tags: [BUILDING],
    }).unwrap();
  return [deleteBuilding, data];
};
